import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getShipnameList } from "../Actions/HelpersAPI";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";
import swal from "sweetalert";
import axios from "axios";
import * as $ from "jquery";
import API from "../helpers/api";
import Role from "../helpers/role";
import Autocomplete from "react-autocomplete";
import { searchsettingsMgmt } from "../Actions/ShippingSettings";
import { ThemeProvider } from "react-bootstrap";
toast.configure();

const SearchItem = {
  shipId: 0,
  toMail: "",
  ccMail: "",
  shipName: "",
  PageNumber: 1,
  PageSize: 25,
};

let userRole = localStorage.getItem("UserRoles");
let user = JSON.parse(localStorage.getItem("currentUser"));
class AddShippingSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("currentUser")),
      searchData: {
        shipId: 0,
        shipName: "",
        toMail: "",
        ccMail: "",
      },
      InvalidToMail: [],
      InvalidCCMail: [],
      tomail: [],
      ccmail: [],
      verifytomail: [],
      verifyccmail: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Settings" });
    this.props.dispatch(getShipnameList());
  }

  handleInputChange(e) {
    this.state.searchData[e.target.name] = e.target.value;
    this.setState({});
  }
  validateToEmail = async (email) => {
    email.map((item) => {
      if (item !== "") {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (item.match(mailformat)) {
        } else {
          var c = this.state.InvalidToMail.push(item);
          this.setState(
            {
              InvalidToMail: this.state.InvalidToMail,
            },
            () => {
              console.log(this.state.InvalidToMail);
              console.log(this.state.tomail);
            }
          );
        }
      }
    });
  };
  validateCcEmail = async (email) => {
    email.map((item) => {
      if (item !== "") {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (item.match(mailformat)) {
        } else {
          var e = this.state.InvalidCCMail.push(item);
          this.setState(
            {
              InvalidCCMail: this.state.InvalidCCMail,
            },
            () => {
              console.log(this.state.InvalidCCMail);
              console.log(this.state.ccmail);
            }
          );
        }
      }
    });
  };

  SubmitSettings = async () => {
    const { dispatch } = this.props;
    this.state.InvalidCCMail = [];
    this.state.InvalidToMail = [];
    let a = [$("div.tomail>input").val()];
    var b = [];
    if (a[0]) {
      b = a.concat(this.state.tomail);
    }
    if (b.length !== 0) {
      this.state.verifytomail = b;
    } else {
      this.state.verifytomail = this.state.tomail;
    }
    if (this.state.verifytomail.length !== 0) {
      if (this.state.searchData.shipName != "") {
        await this.validateToEmail(b);
        console.log(this.state.InvalidToMail.length);
        if (this.state.InvalidToMail.length > 0) {
          swal("Error!", "Invalid tomail", "warning");
          return;
        }
        let f = [$("div.ccmail>input").val()];
        var g = [];
        if (f[0]) {
          g = f.concat(this.state.ccmail);
        }
        if (g.length !== 0) {
          this.state.verifyccmail = g;
        } else {
          this.state.verifyccmail = this.state.ccmail;
        }
        if (this.state.verifyccmail.length !== 0) {
          await this.validateCcEmail(g);
          if (this.state.InvalidCCMail.length > 0) {
            swal("Error!", "Invalid ccmail", "warning");
            return;
          }
        }
        let data = {
          shipId: parseInt(this.state.searchData.shipId),
          shipName: this.state.searchData.shipName,
          toMail: this.state.tomail
            ? this.state.tomail.length === 0
              ? null
              : this.state.tomail.toString()
            : null,
          ccMail: this.state.ccmail
            ? this.state.ccmail.length === 0
              ? null
              : this.state.ccmail.toString()
            : null,
        };
        let url = `${API.AddShippingSettings}`;
        axios
          .put(url, data)
          .then((response) => {
            if (response.status === 500) {
              swal(
                "Error!",
                "Error when updating the data. Try again.",
                "warning"
              );
            } else {
              if (response.data === "Successfully Updated") {
                toast.success("Added Successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                this.state.tomail = [];
                this.state.ccmail = [];
                this.state.InvalidCCMail = [];
                this.state.InvalidToMail = [];
                this.state.verifytomail = [];
                this.state.verifyccmail = [];
                dispatch(searchsettingsMgmt(SearchItem, 1));
                this.moveSettingsList();
              } else {
                swal(
                  "Error!",
                  "No client assigned for this ship. Please assign client.",
                  "warning"
                );
              }
            }
          })
          .catch((error) => {
            swal(
              "Error!",
              "Something went wrong. Please try again.",
              "warning"
            );
            console.log("Error in Add settings Visitor" + error);
          });
      } else {
        swal("Error!", "Please select the ship", "warning");
      }
    } else {
      swal("Error!", "To Email is mandatory", "warning");
    }
  };

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    this.state.searchData[field] = value;
    this.state.searchData[fieldId] = id;
    this.setState({});
  };

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList, showSidePane } = this.props;
    const { tomail, ccmail } = this.state;
    /*    let ScreenWidth = window.innerWidth;
    console.log("width", ScreenWidth); */

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">

                <div
                  className="card MM-card-header mt-2 mb-0"
                  style={{ backgroundColor: "white", border: "0px", padding: '0rem' }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2 pl-3"
                      style={{ color: "092a51" }}
                    >
                      Add Settings
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row pb-3">
                    <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                      <div className="autocomplete-wrappers">
                        <label className="form-label">Ship Name<span className="mandatory">*</span></label>
                        <br></br>
                        <Autocomplete
                          contentEditable={true}
                          value={this.state.searchData.shipName}
                          inputProps={{
                            placeholder: "Ship Name",
                          }}
                          items={ShipNameList ?? []}
                          getItemValue={(item) => item.shipName}
                          shouldItemRender={this.renderShipNameTitle.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdown">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}
                            >
                              {item.shipName}
                            </div>
                          )}
                          onChange={(e) => this.handleAnnualSearchChange(e)}
                          onSelect={(value, item) =>
                            this.handleAnnualSelectChange(
                              value,
                              "shipName",
                              item.shipID,
                              "shipId"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className={showSidePane ? "col-lg-4" : "col-lg-4 "}>
                      <label className="form-label">To Email<span className="mandatory">*</span></label>
                      <br></br>
                      <ReactMultiEmail
                        className="tomail"
                        emails={tomail}
                        onChange={(_emails) => {
                          this.setState({ tomail: _emails }, () => {
                            console.log("valu", $("div.tomail>input").val());
                          });
                        }}
                        getLabel={(email, index, removeEmail) => {
                          return (
                            <label
                              className="m-1"
                              key={index}
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: "14px",
                                wordBreak: "break-word",
                              }}
                            >
                              {email}
                              <span
                                style={{
                                  fontSize: "20px",
                                  verticalAlign: "middle",
                                  marginLeft: ".25rem",
                                }}
                                data-tag-handle
                                name="delete"
                                onClick={() => removeEmail(index)}
                              >
                                &times;
                              </span>
                            </label>
                          );
                        }}
                      />
                    </div>
                    <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                      <label className="form-label">Cc Email</label>
                      <br></br>
                      <ReactMultiEmail
                        className="ccmail"
                        emails={ccmail}
                        onChange={(_emails) => {
                          this.setState({ ccmail: _emails });
                        }}
                        getLabel={(email, index, removeEmail) => {
                          return (
                            <label
                              className="m-1"
                              key={index}
                              style={{
                                backgroundColor: "lightgray",
                                fontSize: "14px",
                                wordBreak: "break-word",
                              }}
                            >
                              {email}
                              <span
                                style={{
                                  fontSize: "20px",
                                  verticalAlign: "middle",
                                  marginLeft: ".25rem",
                                }}
                                data-tag-handle
                                name="delete"
                                onClick={() => removeEmail(index)}
                              >
                                &times;
                              </span>
                            </label>
                          );
                        }}
                      />
                    </div>
                    <div
                          className={
                            userRole == Role.staff
                              ? "col-lg-12 pt-3"
                              : "col-lg-12 pt-3"
                          }
                        >
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SubmitSettings()}
                            >
                              {" "}
                              Submit{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.moveSettingsList()}
                            >
                              {" "}
                              Cancel{" "}
                            </button>
                          </div>
                        </div>
                  </div>
                </div>
              </div>
              {/* <div
                className={
                  userRole == Role.staff
                    ? "col-lg-12 pt-3"
                    : "col-lg-12 pt-3"
                }
              >
                <br></br>
                <div
                  className="search-btn-col"
                  style={{ textAlign: "end" }}
                >
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    type="submit"
                    onClick={() => this.SubmitSettings()}
                  >
                    {" "}
                    Submit{" "}
                  </button>
                  <button
                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                    type="button"
                    onClick={() => this.moveSettingsList()}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                </div>
              </div> */}

            </div>
          </div>
        </div>
      </div>
    );
  }

  moveSettingsList = () => {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    history.push("/Home/Settings");
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ShipNameList: state.UserManageReducer.ShipNameList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddShippingSettings)
);
